import { Box, Theme, useMediaQuery, useTheme } from '@material-ui/core';
import { FC } from 'react'
import LanguageSwitcher from './main/LanguageSwitcher';
import hilabLogo from '../assets/hilab-logo.svg'
const Header: FC = (): JSX.Element => {
  
  const theme: Theme = useTheme<Theme>()
  const matchsm: boolean = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box display="flex" gridGap={10} flexWrap="wrap" px={matchsm ? 2 : 6} pb={2} pt={6}>
      <Box><img width="140px" src={hilabLogo} alt="hilab"/></Box>
      <Box flex="1"></Box>
      <Box minWidth="200px">
        <LanguageSwitcher />
      </Box>
    </Box>
  );
}

export default Header;
